import { formatDate, parseDate } from "global/Utility/TSFunctions";
import * as IXrmOptions from "model/AttributeOptionSets.type";
import * as IXrmTypes from "model/CRM";
import * as ICustomTypes from "model/CRM.type";
import { EGroupConfigurationStatus, IEntityReferenceValue, IGroupConfigurationConfig, IGroupConfigurationData, IRef } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

/**
 * Makes the json snapshot compliant to latest changes of CRM record
 */
export class ApplyGroupConfigurationSnapshotTransformer extends BaseJsonTransformer {
    config: IGroupConfigurationConfig;
    account: ICustomTypes.IAccountExtended;

    constructor(config: IGroupConfigurationConfig, account: ICustomTypes.IAccountExtended) {
        super();

        this.config = config;
        this.account = account;
    }

    async transformGroupConfiguration(json: IGroupConfigurationData, snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot): Promise<void> {

        if (snapshot.bcbs_operativedate || snapshot.createdon)
            json.operativeDate = {
                type: 'date',
                value: formatDate(parseDate(snapshot.bcbs_operativedate ?? snapshot.createdon!, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:yyyy-MM-dd')
            }

        if (snapshot.bcbs_effectivedate)
            json.effectiveDate = {
                type: "date",
                value: formatDate(parseDate(snapshot.bcbs_effectivedate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:yyyy-MM-dd')
            }

        if (snapshot.bcbs_changetypecode) {
            const name = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_changetypecode[snapshot.bcbs_changetypecode as IXrmOptions.bcbs_groupconfigurationsnapshot.Tbcbs_changetypecode].name;

            json.changeType = {
                type: 'optionset',
                name: name,
                value: snapshot.bcbs_changetypecode,
            }
        }

        if (snapshot.bcbs_fundingtypecode) {
            const name = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode[snapshot.bcbs_fundingtypecode as IXrmOptions.bcbs_groupconfigurationsnapshot.Tbcbs_fundingtypecode].name;
            json.fundingType = {
                type: 'optionset',
                name: name,
                value: snapshot.bcbs_fundingtypecode,
            };
        }

        if (snapshot.bcbs_shortname !== undefined) {
            json.bcbs_shortname = snapshot.bcbs_shortname;
        }

        // Status Mapping
        // Mapping JSON status code to cases where user might have been reactivated the group configuration
        if (snapshot.statuscode === IXrmOptions.bcbs_groupconfigurationsnapshot.statuscode["Cancelled(808900011)"].value) {
            const t = this.config.cache.options_groupConfigurationStatusReasons.find(q => q.data?.value === EGroupConfigurationStatus.Cancelled);

            if (t?.data)
                json.status = t.data;
        }
        else if (snapshot.statuscode === IXrmOptions.bcbs_groupconfigurationsnapshot.statuscode["Transferred to Other LOB(808900012)"].value) {
            const t = this.config.cache.options_groupConfigurationStatusReasons.find(q => q.data?.value === EGroupConfigurationStatus["Transferred to Other LOB"]);

            if (t?.data)
                json.status = t.data;
        } else if (snapshot.statuscode === IXrmOptions.bcbs_groupconfigurationsnapshot.statuscode["Transfer to Other LOB in Progress(808900014)"].value) {
            const t = this.config.cache.options_groupConfigurationStatusReasons.find(q => q.data?.value === EGroupConfigurationStatus["Transferred to Other LOB in Progress"]);

            if (t?.data)
                json.status = t.data;
        } else if (snapshot.statuscode === IXrmOptions.bcbs_groupconfigurationsnapshot.statuscode["Cancellation in Progress(808900013)"].value) {
            const t = this.config.cache.options_groupConfigurationStatusReasons.find(q => q.data?.value === EGroupConfigurationStatus["Cancellation in Progress"]);

            if (t?.data)
                json.status = t.data;
        } else {
            const t = this.config.cache.options_groupConfigurationStatusReasons.find(q => q.data?.value === EGroupConfigurationStatus["Active"]);

            if (t?.data)
                json.status = t.data;
        }

        if (snapshot._bcbs_opportunityid_value) {

            // TODO snapshotextended
            //@ts-ignore
            const opportunityRefName = snapshot['_bcbs_opportunityid_value@OData.Community.Display.V1.FormattedValue'];

            const opportunityRef: IEntityReferenceValue = {
                type: "entity",
                entityType: "opportunity",
                id: snapshot._bcbs_opportunityid_value,
                name: opportunityRefName
            };

            json.opportunity = opportunityRef;

        }

        if (this.account.bcbs_lineofbusiness) {
            json.lineOfBusiness = {
                type: 'optionset',
                name: this.account["bcbs_lineofbusiness@OData.Community.Display.V1.FormattedValue"],
                value: this.account.bcbs_lineofbusiness,
            }
        }

        json.id = snapshot.bcbs_groupconfigurationsnapshotid!;

        json.appVersion = (process.env.REACT_APP_VERSION) ?? ""
    }
}